module.exports = __webpack_public_path__ + "media/images/gifts/autonomy/sug_autonomia_4-165a6ea56989156f1a025774926b7536.jpg";